import React from "react";

const TrueIcon = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.55025 9.51503L14.1888 0.876532C14.3374 0.727699 14.5114 0.651699 14.7107 0.648533C14.9101 0.645366 15.0873 0.721366 15.2425 0.876532C15.3977 1.0317 15.4753 1.20987 15.4753 1.41103C15.4753 1.61237 15.3977 1.79061 15.2425 1.94578L6.183 11.0208C6.00217 11.2014 5.79125 11.2918 5.55025 11.2918C5.30925 11.2918 5.09833 11.2014 4.9175 11.0208L0.742501 6.84578C0.593834 6.69695 0.520501 6.52028 0.522501 6.31578C0.524334 6.11145 0.602834 5.9317 0.758001 5.77653C0.913167 5.62137 1.09133 5.54378 1.2925 5.54378C1.49383 5.54378 1.67208 5.62137 1.82725 5.77653L5.55025 9.51503Z"
        fill="white"
      />
    </svg>
  );
};

export default TrueIcon;
